var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _ellipse, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3752 11.2575C62.0344 0.364577 16.3317 1.31178 10.4116 11.2575C11.4378 14.0991 13.4427 19.9718 13.2532 20.7295C13.0638 21.4873 23.5936 29.2544 28.8821 33.0432L56.8247 33.28L69.3752 12.2047V11.2575Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5364 42.0415C41.914 43.3199 38.1926 43.2872 31.4867 42.0415L28.8818 27.8334L39.0643 26.6494H40.7219L48.2996 27.5966L48.5364 42.0415Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25445 32.3329C3.07068 27.1233 6.62282 21.2032 10.6484 11.4944C17.1713 19.5316 25.6176 22.4055 39.5379 26.6497C35.7794 27.0257 32.4338 27.8269 32.4338 31.8593C32.4338 46.541 28.645 48.1986 19.173 56.0131C9.98807 44.3006 5.12502 39.2842 4.25445 32.3329Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8096 22.0207C38.0275 19.332 44.6156 19.3606 56.1202 22.0207",
    stroke: "#999999",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.769 32.3329C76.9528 27.1233 73.4006 21.2032 69.375 11.4944C63.1877 18.4209 55.9688 21.4505 40.4855 26.6497C44.2441 27.0257 47.5896 27.8269 47.5896 31.8593C47.5896 46.541 51.3784 48.1986 60.8505 56.0131C70.0354 44.3006 74.8984 39.2842 75.769 32.3329Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8036 44.4889C27.0192 44.4889 28.0187 43.8445 28.6669 43.0018C29.314 42.1607 29.6716 41.0627 29.6716 39.9105C29.6716 38.7582 29.314 37.6602 28.6669 36.8191C28.0187 35.9764 27.0192 35.332 25.8036 35.332C24.5879 35.332 23.5885 35.9764 22.9402 36.8191C22.2932 37.6602 21.9355 38.7582 21.9355 39.9105C21.9355 41.0627 22.2932 42.1607 22.9402 43.0018C23.5885 43.8445 24.5879 44.4889 25.8036 44.4889Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2196 44.4889C55.4353 44.4889 56.4347 43.8445 57.083 43.0018C57.73 42.1607 58.0876 41.0627 58.0876 39.9105C58.0876 38.7582 57.73 37.6602 57.083 36.8191C56.4347 35.9764 55.4353 35.332 54.2196 35.332C53.0039 35.332 52.0045 35.9764 51.3562 36.8191C50.7092 37.6602 50.3516 38.7582 50.3516 39.9105C50.3516 41.0627 50.7092 42.1607 51.3562 43.0018C52.0045 43.8445 53.0039 44.4889 54.2196 44.4889Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_490_38705",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.696,
    cy: 35.1111,
    rx: 2.28244,
    ry: 2.64229,
    transform: "rotate(43.3105 39.696 35.1111)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.696,
    cy: 35.1111,
    rx: 2.28244,
    ry: 2.64229,
    transform: "rotate(43.3105 39.696 35.1111)",
    fill: "#999999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1739 34.6189C39.1498 34.6444 39.1692 34.605 39.282 34.5934C39.4029 34.581 39.6843 34.6085 39.9414 34.8508L35.8256 39.2167C38.2375 41.4904 41.6953 40.6911 43.5397 38.7346L39.1739 34.6189ZM39.9414 34.8508C40.1984 35.0931 40.2424 35.3724 40.2372 35.4939C40.2322 35.6071 40.194 35.6288 40.2181 35.6033L35.8522 31.4876C34.0078 33.4441 33.4138 36.943 35.8256 39.2167L39.9414 34.8508ZM40.2181 35.6033C40.2422 35.5778 40.2227 35.6172 40.11 35.6288C39.9891 35.6412 39.7077 35.6137 39.4506 35.3714L43.5663 31.0055C41.1545 28.7318 37.6967 29.5311 35.8522 31.4876L40.2181 35.6033ZM39.4506 35.3714C39.1936 35.1291 39.1495 34.8498 39.1548 34.7283C39.1597 34.6151 39.1979 34.5934 39.1739 34.6189L43.5397 38.7346C45.3842 36.7781 45.9782 33.2792 43.5663 31.0055L39.4506 35.3714Z",
    fill: "#999999",
    mask: "url(#path-8-inside-1_490_38705)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinned);
export default __webpack_public_path__ + "static/media/pinned.942fb4c6ce506fba23f2b90249645973.svg";
export { ForwardRef as ReactComponent };